import styled from 'styled-components';
import CompanyEmployeesNumberSelect from './CompanyEmployeesNumberSelect';

const CompanyEmployeesNumberSelectStyled = styled(CompanyEmployeesNumberSelect)`
  ${props => props.theme.input.select};
`;

export default CompanyEmployeesNumberSelectStyled;
